export default __webpack_public_path__ + "static/media/aboutps1.eae2f881.jpg";